import { createMessage } from 'app/modules/messages/actions/createMessage';
import { clearPendingMessages } from 'app/modules/messages/actions/createMessagePending';
import { getPendingMessages } from 'app/modules/messages';

const sendPendingMessages = () => {
  return (dispatch, getState) => {
    let state = getState();
    let pendingMessages = getPendingMessages(state.messages);
    if (pendingMessages) {
      pendingMessages.forEach(message => {
        dispatch(createMessage(message));
      });
    }
    dispatch(clearPendingMessages());
  };
};

export default sendPendingMessages;
